<template>
  <div id="creator_agency_apply_details" :class="isFull === 1 ? 'creator_agency_apply_details top_information1' : ' creator_agency_apply_details'">
    <van-nav-bar :title="title" placeholder fixed @click-left="onClickLeft" left-arrow />
    <van-row>
      <van-col span="24">
        <div style="padding:15px;" v-html="content"></div>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
export default {
  data() {
    return {
      content: undefined,
      title: undefined,
      type: undefined,
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.type = this.$route.query.type ? this.$route.query.type : 4
    this.getList()
  },
  methods: {
    getList(){
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=get_bdm_article",{ params:{ token: token, type: this.type }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.title = res.data.data.title
          this.content = res.data.data.content
        }
      })
    },
    onClickLeft() {
      this.$router.go(-1); // 返回上一页
    },

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/bdm_article.vue